import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { AnnouncementDetailDTO } from '../../openapi/shell-service-openapi';

/**
 * EntityAdapter für Announcement-Detail-Entities.
 *
 * Normalisiert die Entity-Speicherung (ids[] + entities{}).
 */
export const announcementDetailEntitiesAdapter: EntityAdapter<AnnouncementDetailDTO> =
  createEntityAdapter<AnnouncementDetailDTO>();
